import React from 'react';
import { Form } from 'react-bootstrap';

const Checkbox = ({ controlId, label, checked, isInvalid, onChange, errorMessage, disabled = false }) => (
    <Form.Group className='mb-3' controlId={controlId}>
        <Form.Check
            type="checkbox"
            isInvalid={isInvalid}
            label={label}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            size='lg'
        />
        {errorMessage && <span className='text-danger'>{errorMessage}</span>}
    </Form.Group>
);

export default Checkbox;
